export const GrantPermission = {
  can_view: "can_view",
  can_edit: "can_edit",
  can_manage: "can_manage",
} as const;
export type GrantPermission = (typeof GrantPermission)[keyof typeof GrantPermission];

// Roles expose a narrower set than users/tags: no can_edit, and the management
// verb is can_assign (assign the role to users) rather than can_manage.
export const RolePermission = {
  can_view: "can_view",
  can_assign: "can_assign",
} as const;
export type RolePermission = (typeof RolePermission)[keyof typeof RolePermission];

export const GrantSource = {
  direct: "direct",
  inferred: "inferred",
} as const;
export type GrantSource = (typeof GrantSource)[keyof typeof GrantSource];

export interface GrantItem {
  principal: string;
  permission: GrantPermission;
  resource: string;
  source: GrantSource;
}

export interface GrantListResponse {
  items: GrantItem[];
}

export interface GrantRequest {
  principal: string;
  permission: GrantPermission;
}

export interface PendingGrantAddition {
  type: "user" | "group";
  identifier: string;
  label: string;
  permission: GrantPermission;
}

export interface PendingGrantRemoval {
  principal: string;
  permission: GrantPermission;
  label: string;
}

export interface PendingGrantUpdate {
  principal: string;
  oldPermission: GrantPermission;
  newPermission: GrantPermission;
  label: string;
}
